import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { CreateSellerCollectDataStore, SellerPersonalData } from '../../../pages/create-seller-flow/create-seller-flow.store';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-seller-personal-data',
  templateUrl: './seller-personal-data.component.html',
})
export class SellerPersonalDataComponent implements OnDestroy {
  protected readonly CountryISO = CountryISO;
  protected readonly PhoneNumberFormat = PhoneNumberFormat;

  @Output() next = new EventEmitter<SellerPersonalData>();

  private subs = new Subscription();

  constructor(private readonly cs: CreateSellerCollectDataStore) {
    const personalData = this.cs.personalData$.subscribe((personalData) => {
      if (personalData) {
        this.initForm(personalData);
      }
    });

    this.subs.add(personalData);
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public formGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl<any>('', Validators.required),
    socialId: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]{9}$/)]),
  });

  public submit() {
    this.next.emit({
      firstName: this.formGroup.get('firstName')!.value,
      lastName: this.formGroup.get('lastName')!.value,
      email: this.formGroup.get('email')!.value,
      socialId: this.formGroup.get('socialId')!.value,
      phone: this.formGroup.get('phone')!.value?.e164Number,
    });
  }
  private initForm(data: SellerPersonalData) {
    this.formGroup.patchValue(
      {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        socialId: data.socialId,
        phone: data.phone,
      },
      { emitEvent: false },
    );
  }
}
